module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "artwork",
    class: _vm.classArtwork
  }, [_c('div', {
    staticClass: "artwork__bg-color"
  }), _vm._v(" "), (_vm.content) ? _c('div', {
    ref: "inner",
    staticClass: "artwork__inner",
    class: _vm.classesInner
  }, [_c('div', {
    staticClass: "artwork__bg"
  }, [_c('div', {
    ref: "img_background",
    staticClass: "artwork__bg-image"
  }, [(_vm.oeuvre2) ? _c('img', {
    attrs: {
      "src": _vm.oeuvre2,
      "alt": ((_vm.content.title) + " - " + (_vm.content.artiste))
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "artwork__content"
  }, [_c('div', {
    staticClass: "artwork__col artwork__col--infos artwork__col--mobile-only"
  }, [_c('div', {
    ref: "infos",
    staticClass: "infos"
  }, [(_vm.content.artiste) ? _c('p', {
    staticClass: "infos__author"
  }, [_vm._v(_vm._s(_vm.content.artiste))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    ref: "img_oeuvre",
    staticClass: "artwork__col artwork__col--oeuvre"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHome),
      expression: "!isHome"
    }],
    ref: "infos",
    staticClass: "infos"
  }, [_c('div', {
    staticClass: "infos__top"
  }, [(_vm.content.title) ? _c('p', {
    staticClass: "infos__name"
  }, [_vm._v(_vm._s(_vm.content.title))]) : _vm._e(), _vm._v(" "), (_vm.content.artiste) ? _c('p', {
    staticClass: "infos__author"
  }, [_vm._v(_vm._s(_vm.content.artiste))]) : _vm._e()]), _vm._v(" "), (_vm.content.credits) ? _c('p', {
    staticClass: "infos__credits"
  }, [_vm._v(_vm._s(_vm.content.credits) + " "), (_vm.content.date) ? _c('span', [_vm._v("– " + _vm._s(_vm.content.date))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.content.credits && _vm.content.date) ? _c('p', {
    staticClass: "infos__credits"
  }, [_vm._v(_vm._s(_vm.content.date))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "oeuvre-container"
  }, [(_vm.oeuvre1) ? _c('img', {
    staticClass: "oeuvre-img--desktop",
    attrs: {
      "src": _vm.oeuvre1,
      "alt": ((_vm.content.title) + " - " + (_vm.content.artiste))
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHome),
      expression: "isHome"
    }],
    staticClass: "oeuvre-img--mobile",
    attrs: {
      "src": "/static/assets/img/jardins_small.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "artwork__col artwork__col--infos"
  }, [_c('div', {
    ref: "infos",
    staticClass: "infos"
  }, [(_vm.content.title) ? _c('p', {
    staticClass: "infos__name"
  }, [_vm._v(_vm._s(_vm.content.title))]) : _vm._e(), _vm._v(" "), (_vm.content.artiste) ? _c('p', {
    staticClass: "infos__author"
  }, [_vm._v(_vm._s(_vm.content.artiste))]) : _vm._e(), _vm._v(" "), (_vm.content.credits) ? _c('p', {
    staticClass: "infos__credits"
  }, [_vm._v(_vm._s(_vm.content.credits) + " "), (_vm.content.date) ? _c('span', [_vm._v("– " + _vm._s(_vm.content.date))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.content.credits && _vm.content.date) ? _c('p', {
    staticClass: "infos__credits"
  }, [_vm._v(_vm._s(_vm.content.date))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "promo"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHome),
      expression: "!isHome"
    }],
    staticClass: "promo__logo-jardins"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/img/jardins_small.png",
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.isHome) ? _c('p', {
    staticClass: "promo__text"
  }, [_vm._v("Retrouvez cette plante dans l’expo Jardins au Grand Palais jusqu’au 24 juillet 2017 et visitez là autrement avec le parcours botanique de l’application !")]) : _c('p', {
    staticClass: "promo__text"
  }, [_vm._v("Miroir du monde, le jardin rend compte d'une manière de voir la nature, de la mettre en scène et de la penser.")]), _vm._v(" "), _c('a', {
    staticClass: "promo__btn",
    attrs: {
      "href": "http://www.grandpalais.fr/fr/article/jardins-lapplication-mobile-de-lexposition",
      "target": "_blank"
    },
    on: {
      "mouseenter": function($event) {
        _vm.onMouseEnter()
      }
    }
  }, [_c('i', {
    staticClass: "smartphone"
  }), _vm._v(" "), _c('span', [_vm._v("Découvrez l’appli de l’exposition")])])])])])]) : _vm._e()])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-6932b96c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Artwork/index.vue
 ** module id = 752
 ** module chunks = 2
 **/